import { render, staticRenderFns } from "./PatientIdentity.vue?vue&type=template&id=79879be6&"
import script from "./PatientIdentity.vue?vue&type=script&lang=js&"
export * from "./PatientIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports